const Embed = require('../embed/embed')
Embed.init()
